import SpriteSymbol from "../../../../svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "SolidMapPinOn",
  "use": "SolidMapPinOn-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 24 24\" id=\"SolidMapPinOn\"><defs><path d=\"M12 4C8.683 4 6 6.572 6 9.752c0 3.427 3.789 8.152 5.349 9.952a.875.875 0 0 0 1.311 0c1.551-1.8 5.34-6.525 5.34-9.952C18 6.572 15.317 4 12 4zm0 8a2 2 0 1 1 .001-4.001A2 2 0 0 1 12 12z\" id=\"SolidMapPinOn_solid-map-pin-on\" /></defs><use xlink:href=\"#SolidMapPinOn_solid-map-pin-on\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol